var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCloudError = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 357 182"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#jottacloud_CloudError.svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#jottacloud_CloudError.svg__b)",
  fillRule: "evenodd",
  d: "M289.975 82.074C289.975 36.986 248.655 0 200.1 0c-24.627 0-46.929 9.97-63.213 26.097a29 29 0 0 0-.697.647C127.051 35.948 16.477 147.25 5.918 157.892-5.102 169-.27 182 16.574 182h288.763c29.914 0 50.75-22.912 50.75-51.158 0-28.254-22.719-51.168-50.75-51.168a50.3 50.3 0 0 0-15.362 2.4",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeOpacity: 0.6,
  strokeWidth: 5,
  d: "M181.393 84.575c0 6.112-5.401 11.067-12.065 11.067-6.662 0-12.063-4.955-12.063-11.068m65.631 0c0 6.114-5.401 11.068-12.065 11.068s-12.063-4.955-12.063-11.068"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeOpacity: 0.3,
  strokeWidth: 8,
  d: "M165.632 133.355c3.966-9.471 13.848-16.181 25.412-16.181 11.917 0 22.048 7.126 25.759 17.056"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "jottacloud_CloudError.svg__b",
  x1: 26211.6,
  x2: 21744.5,
  y1: 1965.6,
  y2: 20675.8,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#CFCFCF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E2E2E2"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "jottacloud_CloudError.svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h356.087v182H0z"
})))));
export default SvgCloudError;